import Urls from "../../constants/urls";
import backBody from "./imgs/ChaseIO_BackBody.jpg";
import body from "./imgs/ChaseIO_Body.jpg";
import frontBody from "./imgs/ChaseIO_FrontBody.jpg";
import frontCounter from "./imgs/ChaseIO_FrontCounter.jpg";

export const homeUrl = Urls.campionBoatRoom.frontCounter.path;

export const frontCounterHotspots = [
    {
        type: "arrow",
        xPosition: -110,
        yPosition: -45,
        zPosition: 0,
        xRotation: -90,
        yRotation: 0,
        zRotation: 180,
        radius: 10,
        link: Urls.campionBoatRoom.body.path,
    },
    {
        type: "spot",
        xPosition: -130,
        yPosition: -45,
        zPosition: 90,
        xRotation: -90,
        yRotation: 0,
        zRotation: 90,
        radius: 10,
        link: Urls.campionBoatRoom.frontBody.path,
    },
    {
        type: "spot",
        xPosition: -130,
        yPosition: -45,
        zPosition: -90,
        xRotation: -90,
        yRotation: 0,
        zRotation: 90,
        radius: 10,
        link: Urls.campionBoatRoom.backBody.path,
    }
];
export const backBodyHotspots = [
    {
        type: "spot",
        xPosition: -104,
        yPosition: -15,
        zPosition: -50,
        xRotation: -90,
        yRotation: 3,
        zRotation: 180,
        radius: 10,
        link: Urls.campionBoatRoom.body.path,
    },
    {
        type: "arrow",
        xPosition: -100,
        yPosition: -55,
        zPosition: 60,
        xRotation: -90,
        yRotation: 0,
        zRotation: 210,
        radius: 13,
        link: Urls.campionBoatRoom.frontCounter.path,
    },
];
export const bodyHotspots = [
    {
        type: "arrow",
        xPosition: -40,
        yPosition: -25,
        zPosition: 70,
        xRotation: -90,
        yRotation: 60,
        zRotation: 180,
        radius: 10,
        link: Urls.campionBoatRoom.frontCounter.path,
    },
    {
        type: "arrow",
        xPosition: -81,
        yPosition: -45,
        zPosition: -1,
        xRotation: -90,
        yRotation: 0,
        zRotation: 180,
        radius: 10,
        link: Urls.campionBoatRoom.frontBody.path,
    },
    {
        type: "arrow",
        xPosition: 60,
        yPosition: -60,
        zPosition: -0,
        xRotation: -90,
        yRotation: -180,
        zRotation: 180,
        radius: 11,
        link: Urls.campionBoatRoom.backBody.path,
    }
];
export const frontBodyHotspots = [
    {
        type: "arrow",
        xPosition: -100,
        yPosition: -35,
        zPosition: 90,
        xRotation: -90,
        yRotation: 10,
        zRotation: 90,
        radius: 10,
        link: Urls.campionBoatRoom.backBody.path,
    },
    {
        type: "arrow",
        xPosition: -80,
        yPosition: -45,
        zPosition: 30,
        xRotation: -90,
        yRotation: 0,
        zRotation: 90,
        radius: 10,
        link: Urls.campionBoatRoom.body.path,
    },
    {
        type: "arrow",
        xPosition: -85,
        yPosition: -45,
        zPosition: -35,
        xRotation: -90,
        yRotation: -20,
        zRotation: 90,
        radius: 10,
        link: Urls.campionBoatRoom.frontCounter.path,
    }
];

export const rooms = [
    {
        name: "Front Counter",
        img: frontCounter,
        route: Urls.campionBoatRoom.frontCounter,
        yRotation: 360,
    },
    {
        name: "Back Body",
        img: backBody,
        route: Urls.campionBoatRoom.backBody,
        yRotation: -88,
    },
    {
        name: "Body",
        img: body,
        route: Urls.campionBoatRoom.body,
        yRotation: 90,
    },
    {
        name: "Front Body",
        img: frontBody,
        route: Urls.campionBoatRoom.frontBody,
        yRotation: 90,
    },
];